<template>
	<div>
		<div>欢迎进入</div>
		<div>中南民族大学学生宿舍预付费系统</div>
	</div>
</template>

<script>
	export default {
		name: "Index",
	}
</script>

<style scoped>



</style>